export enum paginationEnums {
  dots = '...',
}
